export const MAIN_CHANNEL = 'TM_MAIN_CHANNEL'
